module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-white@2x-9b8986c0.png";